import React from 'react';
import { AppProvider } from '@src/context';
import "@styles/global.css"

//Fontsource
import '@fontsource-variable/open-sans/wdth.css'; // Width axis

export const wrapRootElement = ({ element }) => <AppProvider>{element}</AppProvider>;
